import { Link } from "react-router-dom";
import { Layout } from "../componentes/Layout";
import { useSessao } from "../estado/sessao";

/**
 * Destino da aba "Mais" da nav-inferior (mobile) — Templates/Equipe/Sair, itens administrativos
 * de uso esporádico que não cabem nas 4 abas principais. Página normal, não painel flutuante: ver
 * NavInferior.tsx pro motivo (evitar overlay/modal no mobile, princípio já seguido no resto do
 * app). Em desktop essas mesmas rotas continuam acessíveis pela `.nav-topo` de sempre.
 */
export function Mais() {
  const { usuario, sair } = useSessao();

  return (
    <Layout>
      <main className="container">
        <h2>Mais</h2>
        <div className="cartao" style={{ marginTop: 16 }}>
          {usuario?.papel === "ADMIN" && (
            <>
              <Link to="/templates" className="item-lista"><div className="item-lista-eyebrow">📐 CONFIGURAÇÃO</div><div className="item-lista-titulo">Modelos de checklist</div></Link>
              <Link to="/equipe" className="item-lista"><div className="item-lista-eyebrow">👥 ORGANIZAÇÃO</div><div className="item-lista-titulo">Equipe</div></Link>
            </>
          )}
          <Link to="/perfil" className="item-lista"><div className="item-lista-eyebrow">🔐 CONTA</div><div className="item-lista-titulo">Perfil e senha</div></Link>
        </div>

        <div className="cartao" style={{ marginTop: 16, padding: 16 }}>
          <div style={{ fontSize: 13, color: "var(--texto-suave)", marginBottom: 10 }}>
            {usuario?.organizacaoNome}
          </div>
          <button type="button" className="botao botao-texto" onClick={() => void sair()}>
            Sair
          </button>
        </div>
      </main>
    </Layout>
  );
}
